module.exports = "<p class=\"empty-state\"\n  *ngIf=\"message\">\n  {{ message }}\n</p>\n";